import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "service-item"
}
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text" }

import { TService } from '@/types';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Service',
  props: {
    service: null
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (__props.service)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: `https://myplusplus.com/img/${__props.service.image}`,
            alt: "Image for the service"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, _toDisplayString(__props.service.title), 1),
          _createElementVNode("p", null, _toDisplayString(__props.service.description), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})